/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import React from 'react'

const FooterMobileMenuWrapper = props => {
  const {children, forwardedRef} = props

  return (
    <Block
      ref={forwardedRef}
      overrides={{
        Block: {
          style: ({$theme}) => ({
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: $theme.colors.primary700,
            textAlign: 'center',
            display: 'block',
            [$theme.media.small]: {
              display: 'none',
            },
          }),
        },
      }}
    >
      {children}
    </Block>
  )
}

export default FooterMobileMenuWrapper
